module.exports = __webpack_public_path__ + "assets/img/pyramid_text2.15a44e6d.png";